module.exports = __webpack_public_path__ + "static/media/3040168000_01.dccd7e92.jpg";